/* eslint-disable no-loop-func */
import { useState, useContext, useRef } from "react"
import Modal from "."
import useService from "../../hooks/useService"
import { NotificationContext } from "../../contexts/NotificationContext";
import {
    
    DialogContent,
    Typography,
    Button,
    Tooltip
} from "@mui/material";

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import styled from "styled-components";
import * as XLSX from "xlsx";
import {
    DataGrid,
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarExport,
    GridToolbarDensitySelector,
    GridColDef,
} from "@mui/x-data-grid";
import { bulkMintedOrders } from "../../services/Transactions";
import { MOP, STATES_CODES_CLIENT, TRANSACTION_TYPES } from "../../utils/constant";


const InputFieldContainer = styled.div`
  margin: 20px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  label {
    margin-bottom: 0px;
  }
`;

const ModalActionsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
const FirstButton = styled(Button)`
  margin-right: 10px !important;
`;

const StyledDialogContent = styled(DialogContent)`
  padding: 16px;
`;


const DataGridContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  height: 400px;
`;

const NoteText = styled(Typography)`
  margin-top: 10px !important;
`;

const Input = styled.input`
  display: none;
`;

const BulkUploadOrderModal = (props: { open: boolean, onClose: () => any }) => {
    const { onClose, open } = props
    const { execute } = useService()
    const { notify } = useContext(NotificationContext)
    const [loading, setLoading] = useState(false);
    const [storeRows, setStoreRows] = useState([]);
    const [selectedRowIds, setSelectedRowIds] = useState([]);
    const [uploaded, setUploaded] = useState(false);
    const hiddenFileInput = useRef(null);

    const closeHandler = () => {
        onClose()
        setStoreRows([])
    }

    const getFileRows = async (file: any) => {
        try {
            let data = await file.arrayBuffer();
            const wb = XLSX.read(data, { type: "binary" });
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            let dataParse = XLSX.utils.sheet_to_json(ws);
            if (dataParse?.length > 0) {
                dataParse = dataParse.map((entry: any, index: any) => {
                    return {
                        id: index + 1,
                        buyerName: entry["buyer-name"],
                        mobileNumber: entry["buyer-mobile-number"]?.toString(),
                        city: entry["ship-city"],
                        state: entry["ship-state"],
                        pin: entry.pin,
                        pan: entry.pan,
                        utr: entry.UTR,
                        mop: entry.MOP,
                        qty: entry.Qty,
                        sku: entry.sku,
                        taxableAmount: entry.taxableamount,
                        bank: entry.Bank,
                        rate: entry.Rate,
                        totalPrice: entry.totalprice,
                        address: entry["delivery-address"],
                        // serialNumber: typeof (entry.serialNumber) !==
                        //     'number' ? entry.serialNumber?.split(',').map(Number) : [entry.serialNumber],
                        serialNumber: typeof(entry.serialNumber) !== 'number' ? entry.serialNumber?.split(',').map((num: string) => parseInt(num.trim())) : [entry.serialNumber],
                        productName: entry['product-name'],
                        employeeId: entry['employee-id'],
                        refType: entry['reference-type'],
                        userType: entry['user-type'],

                    };
                });
            }
            let element: any = document.getElementById("fileUploadPicker");
            if (element) {
                element.value = "";
            }
            return dataParse;
        } catch (error) {
            throw error;
        }
    };

    const handleUpload = async () => {
        try {
            let uploadInput: any = document.getElementById("filePickerButton");
            if (uploadInput) {
                if (uploadInput.files.length > 0) {
                    let file = uploadInput.files[0];
                    setLoading(true);
                    let response: any = await getFileRows(file);
                    if (response.length > 0) {
                        setStoreRows(response);
                        setUploaded(false);
                    }
                    setLoading(false);
                }
            }
        } catch (error) {
            notify('Error retreiving user data', 'error')
            setLoading(false);
        }
    };

    const hasErrors = () => {
        try {
            if (!storeRows) {
                notify('Please select a valid file for upload', 'error')
                return true;
            }
            return false;
        } catch (error) {
            console.error(error);
            notify('Please select a valid file for upload', 'error')
            throw error;
        }
    };

    const dataRowCheck = (rowDetails: any) => {
        try {
            let result = false;
            if (!rowDetails.sku) return 'Product ID is missing'
            if (!rowDetails.mobileNumber) return 'Buyer-mobile-number is missing'
            if (!rowDetails.buyerName) return 'Buyer-name is missing'
            if (!rowDetails.qty) return 'Qty is missing'
            if (Number(rowDetails?.qty) <= 0) return 'Qty must be greater than 0'
            // if (!rowDetails.serialNumber) return 'Serial number is missing'
            if (!rowDetails.rate) return 'Rate is missing'
            if (!rowDetails.taxableAmount) return 'Taxable is missing'
            if ( rowDetails?.taxableAmount < 0) return 'Taxable must be greater than 0'
            if (!rowDetails.mop) return 'MOP is missing'
            if (!rowDetails.totalPrice) return 'Total price is missing'
            if ( rowDetails?.totalPrice < 0) return 'Total price must be greater than 0'
            if (!rowDetails.address) return 'Delivery address is missing'
            if (!rowDetails.pin) return 'PIN is missing'
            if ((rowDetails.pin?.toString().length!==6)) return 'PIN must be of 6 digit'
            if (!rowDetails.city) return 'Ship city is missing'
            if (!rowDetails.state) return 'Ship state is missing'
            if (!rowDetails.bank) return 'Bank is missing'
            if (!rowDetails.utr) return 'UTR is missing'
            if (rowDetails?.serialNumber && rowDetails.qty !== rowDetails.serialNumber.length ) return 'Qty. and Serial Numbers mismatch'
            if (rowDetails.mop === "WALLET") return 'Pay by wallet is not a valid payment mode'
            let checkMOP = MOP.filter((el)=>{
                if(rowDetails.mop === el) return el
            })
            if(checkMOP.length === 0) return 'MOP mismatch'
            if(rowDetails.userType!= "RETAIL" && rowDetails.userType!= "EMPLOYEE" && rowDetails.userType!= "F&F" && rowDetails.userType!= "B2B") return "Invalid user type"
            if(rowDetails.userType == "EMPLOYEE" || rowDetails.userType == "F&F"){
                if(!rowDetails.employeeId ) return "Employee id is required"
            }
            let checkState = STATES_CODES_CLIENT.filter((state: any) => {
                if (rowDetails.state.toLowerCase() === state.value.toLowerCase()) {
                    return state
                }
            })
            if (checkState.length === 0) return "Invalid state value"
            return result;
        } catch (error) {
            throw error;
        }
    };

    const onClickUpload = async () => {
        try {

            if (hasErrors()) {
                return;
            }
            let dataRows: any = [];
            if (selectedRowIds.length > 0) {
                for (let id of selectedRowIds) {
                    let rowData = storeRows.find((row: any) => row?.id === id);
                    if (rowData) {
                        dataRows.push(rowData);
                    }
                }
            } else {
                dataRows = [...storeRows];
            }

            let newRows: any = [...storeRows];
            let i = 0;
            while (i !== dataRows.length) {
                let hasError = dataRowCheck(dataRows[i]);
                if (hasError) {
                    let index = storeRows.findIndex((row: any) => row.id === dataRows[i].id);
                    if (index !== -1) {
                        newRows[index] = {
                            ...newRows[index],
                            uploadStatus: "failure",
                            reason: hasError,
                        };
                    }
                    setUploaded(true)
                    dataRows.splice(i, 1);
                } else {
                    i++;
                }
            }
            setStoreRows(newRows);
            if (dataRows.length === 0) {
                notify('Data selected with missing fields', 'error')
                return
            }
            setLoading(true);
            const { data } = await execute(() => bulkMintedOrders({ bulkEntries: dataRows, transactionType: TRANSACTION_TYPES.MINTED_SALES }))
            let response: any = data;
            let newStoreRows: any = [...newRows];
            for (let responseEntry of response) {
                let rowIndex = newStoreRows.findIndex(
                    (row: any) => row.id === responseEntry.id
                );
                if (rowIndex !== -1) {
                    newStoreRows[rowIndex].uploadStatus = responseEntry.uploadStatus;
                    newStoreRows[rowIndex].reason = "";
                    if (responseEntry.uploadStatus === "failure") {
                        newStoreRows[rowIndex].reason = responseEntry.reason;
                    }
                }
            }
            setStoreRows(newStoreRows);
            if (!uploaded) {
                setUploaded(true);
            }
            setLoading(false);
        } catch (error) {
            console.error(error);
            notify('Error uploading file', 'error')
            setLoading(false);
        }
    };

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
                <GridToolbarExport
                    csvOptions={{
                        fileName: "bulk-upload-leads",
                    }}
                />
            </GridToolbarContainer>
        );
    }


    const getRowClassName = (params: any) => {
        let uploadStatus = params.row.uploadStatus || "";
        if (uploadStatus === "success") {
            return "successRow";
        } else if (uploadStatus === "failure") {
            return "failureRow";
        } else {
            return "";
        }
    };

    const getGridColumns = () => {
        let columns: GridColDef[] = [
            {
                field: "id",
                headerName: "Serial No.",
                minWidth: 20,
            },
            {
                field: "sku",
                headerName: "SKU ID",
                minWidth: 150,
                renderCell: (params: any) => {
                    return params.row.sku
                }
            },
            {
                field: "buyerName",
                headerName: "Buyer Name",
                minWidth: 150,
                //   renderCell: (params: any) => {
                //     return params.row['buyer-name']
                //   }
            },
            {
                field: "mobileNumber",
                headerName: "Mobile Number",
                minWidth: 120,
            },
            {
                field: "productName",
                headerName: "Product Name",
                minWidth: 210,
                //   renderCell: (params: any) => {
                //     return params.row['product-name']
                //   }
            },
            {
                field: "qty",
                headerName: "Quantity",
                minWidth: 70,
            },
            {
                field: "serialNumber",
                headerName: "Serial Number",
                minWidth: 120,
            },
            {
                field: "rate",
                headerName: "Rate",
                minWidth: 80,
            },
            {
                field: "taxableAmount",
                headerName: "Taxable Amount",
                minWidth: 70,
            },
            {
                field: "totalPrice",
                headerName: "Total Price",
                minWidth: 120,
            },
            {
                field: "pan",
                headerName: "PAN",
                minWidth: 150,
            },
            {
                field: "bank",
                headerName: "Bank",
                minWidth: 120,
            },
            {
                field: "mop",
                headerName: "MOP",
                minWidth: 100,
            },
            {
                field: "utr",
                headerName: "UTR",
                minWidth: 120,
            },
            {
                field: "address",
                headerName: "Address",
                minWidth: 200,
            },
            {
                field: "city",
                headerName: "City",
                minWidth: 120,
            },
            {
                field: "state",
                headerName: "State",
                minWidth: 120,
            },
            {
                field: "pin",
                headerName: "PIN",
                minWidth: 100,
            },
            {
                field: "employeeId",
                headerName: "Employee-Id",
                minWidth: 100,
            }, {
                field: "refType",
                headerName: "Reference Type",
                minWidth: 150,
            }, {
                field: "userType",
                headerName: "User Type",
                minWidth: 100,
            },
        ]
        if (uploaded) {
            columns.splice(
                0,
                0,
                {
                    field: "uploadStatus",
                    headerName: "Upload Status",
                    width: 100,
                    renderCell: (params: any) => {
                        let name = "";
                        if (params.row.uploadStatus) {
                            name =
                                params.row.uploadStatus === "success" ? "Success" : "Failure";
                        }
                        return (
                            <Tooltip title={name}>
                                <Typography variant="inherit">{name}</Typography>
                            </Tooltip>
                        );
                    },
                    editable: false,
                },
                {
                    field: "reason",
                    headerName: "Reason",
                    width: 200,
                    renderCell: (params: any) => {
                        let name = params.row.reason || "";
                        return (
                            <Tooltip title={name}>
                                <Typography variant="inherit">{name}</Typography>
                            </Tooltip>
                        );
                    },
                    editable: false,
                }
            );
        }
        return columns;
    };

    const renderModalContent = () => {
        return (
            <>
                {storeRows?.length > 0 && (
                    <div >
                        <DataGridContainer>
                            <DataGrid
                                disableRowSelectionOnClick={true}
                                checkboxSelection={true}
                                rows={storeRows}
                                columns={getGridColumns()}
                                onRowSelectionModelChange={(selectedValues: any) => (setSelectedRowIds(selectedValues)
                                )}
                                density="compact"
                                rowHeight={40}
                                autoPageSize
                                getRowClassName={getRowClassName}
                                slots={{ toolbar: CustomToolbar }}
                            // slots={{ toolbar: GridToolbar }}

                            />
                        </DataGridContainer>
                        <NoteText variant="body2">
                            Note: If selected, only the selected rows will be uploaded
                        </NoteText>
                    </div>
                )}
                <InputFieldContainer>
                    <a
                        target="_blank"
                        href={`/assets/Bulk_upload.xlsx`}
                        download rel="noreferrer"
                    >
                        <Button variant="outlined" color="primary">
                            Download Template
                        </Button>
                    </a>
                    <label htmlFor="filePickerButton">
                        <Input
                            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                            id="filePickerButton"
                            type="file"
                            ref={hiddenFileInput}
                            onChange={handleUpload}
                        />
                        <Button
                            disabled={loading}
                            color="primary"
                            variant="contained"
                            component="span"
                        >
                            Select File
                        </Button>
                    </label>
                </InputFieldContainer>
                <ModalActionsContainer>
                    <FirstButton
                        disabled={loading}
                        onClick={() => {
                            setStoreRows([])
                            onClose()
                        }}
                        variant="outlined"
                        color="primary"
                    >
                        Cancel
                    </FirstButton>
                    <Button
                        disabled={loading || storeRows.length === 0}
                        onClick={onClickUpload}
                        variant="contained"
                        color="primary"
                    >
                        Upload
                    </Button>
                </ModalActionsContainer>
            </>
        );
    };

    return (
        <Modal onClose={closeHandler} open={open} title="Bulk upload Orders" >
            <StyledDialogContent>
                {loading && <>
                    <Backdrop
                        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={open}
                    // onClick={handleClose}
                    >
                        <CircularProgress color="inherit" />
                    </Backdrop></>}
                {renderModalContent()}
            </StyledDialogContent>
        </Modal>
    );
};

export default BulkUploadOrderModal
